import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import EditarTransportista from '../../components/transporte/EditarTransportista'
import {filtrarTransporte, abrirModalConductor, editConductorAnadido, recuperarModalConductor, cambiarEstadoConductor, onDeleteConductorAnadido, duplicarConductor, conductorPorDefecto, abrirModalVehiculo,
  editVehiculoAnadido, recuperarModalVehiculo, cambiarEstadoVehiculo, onDeleteVehiculoAnadido, duplicarVehiculo, vehiculoPorDefecto, abrirModalRuta, onDeleteRutaAnadida, rutaPorDefecto,
  submitNuevoTransportista, guardarYnuevoTransporte, reiniciarConductoresVehiculosRutas, seleccionarTodosConductores, deSeleccionarTodosConductores, seleccionarTodosVehiculos,
  deSeleccionarTodosVehiculos, seleccionarTodosRutas, deSeleccionarTodosRutas, deleteSeleccionConductor, deleteSeleccionVehiculo, deleteSeleccionRutaTransportista, fetchEditarTransportista,
  submitEditarTransportista} from '../../actions/transporte/transporte'
import {closeModal} from '../../actions/common'

export function mapStateToProps (state) {
  return {
    ...state.transporte,
    showModal: state.common.showModal,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    formSimpleTable: state.form.simpleTable,
    formModalTransportista: state.form.EditarTransportista,
    paginaActual: state.common.paginaActual,
    auth: state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeModal,
      filtrarTransporte,
      abrirModalConductor,
      editConductorAnadido,
      recuperarModalConductor,
      cambiarEstadoConductor,
      onDeleteConductorAnadido,
      duplicarConductor,
      conductorPorDefecto,
      abrirModalVehiculo,
      editVehiculoAnadido,
      recuperarModalVehiculo,
      cambiarEstadoVehiculo,
      onDeleteVehiculoAnadido,
      duplicarVehiculo,
      vehiculoPorDefecto,
      abrirModalRuta,
      onDeleteRutaAnadida,
      rutaPorDefecto,
      submitNuevoTransportista,
      guardarYnuevoTransporte,
      reiniciarConductoresVehiculosRutas,
      seleccionarTodosConductores,
      deSeleccionarTodosConductores,
      seleccionarTodosVehiculos,
      deSeleccionarTodosVehiculos,
      seleccionarTodosRutas,
      deSeleccionarTodosRutas,
      deleteSeleccionConductor,
      deleteSeleccionVehiculo,
      deleteSeleccionRutaTransportista,
      fetchEditarTransportista,
      submitEditarTransportista
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditarTransportista))